import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Page from 'flarum/common/components/Page';
import Button from 'flarum/common/components/Button';
import NagusiBackNav from '../common/NagusiBackNav';
import AnagramasGame from './AnagramasGame';
import BolillaRetroGame from './BolillaRetroGame';
import NorDaLehoiaGame from './NorDaLehoiaGame';
import LehoidleGame from './LehoidleGame';
import QuienDijoGame from './QuienDijoGame';
import PasatiemposLeaderboard from './PasatiemposLeaderboard';
export default class PasatiemposPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "activeTab", 'hub');
    _defineProperty(this, "selectedLevel", 1);
  }
  oninit(vnode) {
    super.oninit(vnode);
    const routeGame = m.route.param('game');
    if (routeGame === 'quien-dijo' || routeGame === 'quien_dijo') {
      this.activeTab = 'quien_dijo';
    } else if (routeGame === 'lehoidle') {
      this.activeTab = 'lehoidle';
    } else if (routeGame === 'anagramas') {
      this.activeTab = 'anagrams';
    } else if (routeGame === 'bolilla-retro' || routeGame === 'bolilla_retro') {
      this.activeTab = 'bolilla_retro';
    } else if (routeGame === 'nor-da-lehoia' || routeGame === 'nor_da_lehoia') {
      this.activeTab = 'nor_da_lehoia';
    } else if (routeGame === 'clasificacion') {
      this.activeTab = 'leaderboard';
    }
  }
  setTab(tab, level) {
    if (level === void 0) {
      level = 1;
    }
    this.activeTab = tab;
    this.selectedLevel = level;
    m.redraw();
  }
  view() {
    return m("div", {
      className: "PasatiemposPage container"
    }, m(NagusiBackNav, null), m("div", {
      className: "pasatiempos-header"
    }, m("h1", null, "\uD83E\uDDE9 Pasatiempos Aurrera Athletic"), m("p", null, "Pon a prueba tu agilidad mental y conocimiento zurigorri con pasatiempos tem\xE1ticos del Athletic Club."), m("div", {
      className: "pasatiempos-points-badge"
    }, m("i", {
      className: "fas fa-trophy"
    }), " Cada juego aporta hasta ", m("strong", null, "3.000 puntos"), " al Ranking Global (1.000 pts por nivel o tanda)")), m("div", {
      className: "pasatiempos-nav-tabs"
    }, m("button", {
      className: "tab-btn ".concat(this.activeTab === 'hub' ? 'active' : ''),
      onclick: () => this.setTab('hub')
    }, m("i", {
      className: "fas fa-th-large"
    }), m("span", {
      className: "tab-label-full"
    }, "Cat\xE1logo de Juegos"), m("span", {
      className: "tab-label-short"
    }, "Cat\xE1logo")), m("button", {
      className: "tab-btn ".concat(this.activeTab === 'quien_dijo' ? 'active' : ''),
      onclick: () => this.setTab('quien_dijo')
    }, m("i", {
      className: "fas fa-quote-right"
    }), m("span", {
      className: "tab-label-full"
    }, "\xBFQui\xE9n dijo...?"), m("span", {
      className: "tab-label-short"
    }, "\xBFQui\xE9n dijo?")), m("button", {
      className: "tab-btn ".concat(this.activeTab === 'lehoidle' ? 'active' : ''),
      onclick: () => this.setTab('lehoidle')
    }, m("i", {
      className: "fas fa-bullseye"
    }), m("span", {
      className: "tab-label-full"
    }, "Lehoidle"), m("span", {
      className: "tab-label-short"
    }, "Lehoidle")), m("button", {
      className: "tab-btn ".concat(this.activeTab === 'nor_da_lehoia' ? 'active' : ''),
      onclick: () => this.setTab('nor_da_lehoia')
    }, m("i", {
      className: "fas fa-search"
    }), m("span", {
      className: "tab-label-full"
    }, "Nor da Lehoia?"), m("span", {
      className: "tab-label-short"
    }, "Nor da?")), m("button", {
      className: "tab-btn ".concat(this.activeTab === 'bolilla_retro' ? 'active' : ''),
      onclick: () => this.setTab('bolilla_retro')
    }, m("i", {
      className: "fas fa-futbol"
    }), m("span", {
      className: "tab-label-full"
    }, "Bolilla Retro"), m("span", {
      className: "tab-label-short"
    }, "Bolilla")), m("button", {
      className: "tab-btn ".concat(this.activeTab === 'anagrams' ? 'active' : ''),
      onclick: () => this.setTab('anagrams', 1)
    }, m("i", {
      className: "fas fa-font"
    }), m("span", {
      className: "tab-label-full"
    }, "Anagramas Zurigorris"), m("span", {
      className: "tab-label-short"
    }, "Anagramas")), m("button", {
      className: "tab-btn ".concat(this.activeTab === 'leaderboard' ? 'active' : ''),
      onclick: () => this.setTab('leaderboard')
    }, m("i", {
      className: "fas fa-medal"
    }), m("span", {
      className: "tab-label-full"
    }, "Clasificaciones"), m("span", {
      className: "tab-label-short"
    }, "Ranking"))), this.activeTab === 'hub' && this.renderHub(), this.activeTab === 'quien_dijo' && m(QuienDijoGame, null), this.activeTab === 'lehoidle' && m(LehoidleGame, null), this.activeTab === 'nor_da_lehoia' && m(NorDaLehoiaGame, null), this.activeTab === 'bolilla_retro' && m(BolillaRetroGame, null), this.activeTab === 'anagrams' && m(AnagramasGame, {
      level: this.selectedLevel,
      onNavigateTab: tab => this.setTab(tab)
    }), this.activeTab === 'leaderboard' && m(PasatiemposLeaderboard, null));
  }
  renderHub() {
    return m("div", {
      className: "games-hub-grid"
    }, m("div", {
      className: "game-card game-card-featured"
    }, m("div", null, m("div", {
      className: "game-card-icon"
    }, "\uD83D\uDCAC"), m("h3", {
      className: "game-card-title"
    }, "\xBFQui\xE9n dijo...?"), m("p", {
      className: "game-card-desc"
    }, "Descubre qu\xE9 forero escribi\xF3 cada comentario en modo muerte s\xFAbita. Administra tus 3 comodines (50%, P\xFAblico y Llamada) para batir el r\xE9cord del foro."), m("div", {
      className: "game-card-meta"
    }, m("span", {
      className: "badge badge-points"
    }, "R\xE9cord de Racha"), m("span", {
      className: "badge badge-mode"
    }, "Muerte S\xFAbita \xB7 3 Comodines"))), m("div", {
      className: "game-card-actions"
    }, m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-play",
      onclick: () => this.setTab('quien_dijo')
    }, "Jugar Ahora"))), m("div", {
      className: "game-card game-card-featured"
    }, m("div", null, m("div", {
      className: "game-card-icon"
    }, "\uD83C\uDFAF"), m("h3", {
      className: "game-card-title"
    }, "Lehoidle"), m("p", {
      className: "game-card-desc"
    }, "Descubre al le\xF3n oculto en 8 intentos comparando posici\xF3n, dorsal, edad, altura, peso y procedencia con el Radar de Deducci\xF3n en tiempo real."), m("div", {
      className: "game-card-meta"
    }, m("span", {
      className: "badge badge-points"
    }, "Hasta 1.000 pts"), m("span", {
      className: "badge badge-mode"
    }, "8 Intentos \xB7 Radar en vivo"))), m("div", {
      className: "game-card-actions"
    }, m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-play",
      onclick: () => this.setTab('lehoidle')
    }, "Jugar Ahora"))), m("div", {
      className: "game-card"
    }, m("div", null, m("div", {
      className: "game-card-icon"
    }, "\uD83E\uDD81"), m("h3", {
      className: "game-card-title"
    }, "Nor da Lehoia?"), m("p", {
      className: "game-card-desc"
    }, "Adivina qu\xE9 le\xF3n del Athletic se oculta tras las pistas de su ficha oficial: lugar de nacimiento, demarcaci\xF3n, a\xF1o/edad, altura y dorsal. \xA1Cuantas menos pistas uses, m\xE1s puntos ganas!"), m("div", {
      className: "game-card-meta"
    }, m("span", {
      className: "badge badge-points"
    }, "Hasta 1.000 pts"), m("span", {
      className: "badge badge-mode"
    }, "5 Leones misteriosos"))), m("div", {
      className: "game-card-actions"
    }, m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-play",
      onclick: () => this.setTab('nor_da_lehoia')
    }, "Jugar Ahora"))), m("div", {
      className: "game-card"
    }, m("div", null, m("div", {
      className: "game-card-icon"
    }, "\u26BD"), m("h3", {
      className: "game-card-title"
    }, "Bolilla Retro"), m("p", {
      className: "game-card-desc"
    }, "Adivina el resultado oficial de partidos del Athletic en 3 \xE9pocas hist\xF3ricas (2010-2027, 1980-2009, 1901-1979) o ponte a prueba en el modo Muerte S\xFAbita con 3 vidas del Le\xF3n."), m("div", {
      className: "game-card-meta"
    }, m("span", {
      className: "badge badge-points"
    }, "Hasta 3.000 pts"), m("span", {
      className: "badge badge-levels"
    }, "3 Niveles + Muerte S\xFAbita"))), m("div", {
      className: "game-card-actions"
    }, m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-play",
      onclick: () => this.setTab('bolilla_retro')
    }, "Jugar Ahora"))), m("div", {
      className: "game-card"
    }, m("div", null, m("div", {
      className: "game-card-icon"
    }, "\uD83D\uDD24"), m("h3", {
      className: "game-card-title"
    }, "Anagramas Zurigorris"), m("p", {
      className: "game-card-desc"
    }, "Desordena y coloca las letras para descubrir al le\xF3n o leona. Desde el primer equipo masculino y femenino hasta las j\xF3venes promesas de Lezama."), m("div", {
      className: "game-card-meta"
    }, m("span", {
      className: "badge badge-points"
    }, "Hasta 3.000 pts"), m("span", {
      className: "badge badge-levels"
    }, "3 Niveles de Dificultad"))), m("div", {
      className: "game-card-actions"
    }, m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-play",
      onclick: () => this.setTab('anagrams', 1)
    }, "Jugar Ahora"))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/pasatiempos/PasatiemposPage', PasatiemposPage);